import React, { useState, useEffect } from 'react'
import bdLogo from '../../../public/Bitmap.png'

export default function SubscribeSuccess() {
    return (
        <div className='subscription-success-container'>
            <div className='nav-bar'>
                <a
                    href='https://branding.cards'
                    alt='bd-logo'
                    className='bd-logo-container'
                >
                    <img className='bd-logo' src={bdLogo} alt='Brand Deck Logo' />
                </a>
                <div className='back-link-container'>
                    <a className='back-link' href='https://branding.cards'>
                        Back to Branding.Cards
                    </a>
                </div>
            </div>

            <div className='subscription-success-render'>
                <h1>Thank you for your purchase. We'll be in touch shortly with your credentials.</h1>
            </div>
        </div>
    )
}
